import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enJSON from './en.json'
import krJSON from './kr.json'
import plJSON from './pl.json'
import itJSON from './it.json'

const resources = {
    en: { translation: enJSON },
    ko: { translation: krJSON },
    pl: { translation: plJSON },
    it: { translation: itJSON },
}

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    })

export default i18n